<div class="battle-goals-setup-dialog">
  <div class="scroll-container">
    <div class="header" [ghs-label]="'game.battleGoals.setup'"></div>

    <div class="editions">
      <div class="edition">
        <span class="name" [ghs-label]="'game.battleGoals.all'" (click)="selectEdition()"
          [ngClass]="{'selected': currentEdition == ''}"></span>
        <span class="size">({{gameManager.battleGoalManager.getBattleGoals().length}})</span>
      </div>
      @for (edition of editions; track edition) {
      <div class="edition">
        <span class="name" [ghs-label]="'game.battleGoals.edition'" [ghs-label-args]="[edition]"
          (click)="selectEdition(edition)" [ngClass]="{'selected': edition == currentEdition}"></span>
        <span class="size">({{gameManager.battleGoalManager.getBattleGoalsForEdition(edition).length}})</span>
        <input type="checkbox"
          [checked]="gameManager.game.battleGoalEditions.indexOf(edition) != -1 || gameManager.editionRules(edition, false)"
          [disabled]="gameManager.editionRules(edition, false)" (change)="toggleEdition(edition)">
      </div>
      }
    </div>

    <div class="battle-goals">
      @if (battleGoals.length == 0) {
      <span class="warning" [ghs-label]="'game.battleGoals.setup.empty'"></span>
      }
      @for (battlegoal of battleGoals | trackUUID; track battlegoal._trackUUID) {
      <ghs-battlegoal class="battlegoal" [battleGoal]="battlegoal" [flipped]="true"
        [disabled]="!selected(battlegoal) && !filtered(battlegoal) || selectedAlias(battlegoal)" [reveal]="false"
        [selected]="!this.selectedAlias(battlegoal) && selected(battlegoal)" [filtered]="filtered(battlegoal)"
        [ngClass]="{'disabled' : selectedAlias(battlegoal)}"
        (click)="toggleFilter(battlegoal)"></ghs-battlegoal>
      }
    </div>
  </div>
</div>